import { KubernetesObject, V1ContainerPort, V1HTTPIngressPath, V1Ingress, V1IngressServiceBackend } from "@kubernetes/client-node"
import { splitAndTrimComma } from "yam-operator/util"
import { K8SResourceType, KVString, PlanContext } from "yam-types"
import { Settings } from "../settings.d"
import { AccessApproachConfig } from "../types.d"
import { getExternalDNSAnnotations } from "./external-dns"

export const composeIngress = (
  plan: PlanContext, appAccess: AccessApproachConfig, serviceName: string,
  containerPort: V1ContainerPort, servicePort: number, settings: Settings
): KubernetesObject => {
  const planData = plan.data
  const isHttp = appAccess.protocol.startsWith("http")
  const hosts = (appAccess.host instanceof Array) ? appAccess.host : splitAndTrimComma(appAccess.host || '')
  if (isHttp && hosts.length === 0) {
    throw new Error(`Can not create ingress for ${appAccess.protocol.toUpperCase()} service, please check type or host`)
  }
  const defaultPathType = appAccess.advancedFeatures?.ingressPathType || 'ImplementationSpecific'
  const defaultBackend: V1IngressServiceBackend = {
    port: {
      number: servicePort || containerPort.containerPort
    },
    name: serviceName
  }
  // compose ingress
  const noDefault = appAccess.advancedFeatures?.disableDefaultIngressClassAndAnnotations || false
  const defaultAnnotations = noDefault ? {} : (settings.ingressAnnotations || {})
  const defaultLabels = settings.ingressLabels || {}
  const ingressClassName = appAccess.advancedFeatures?.ingressClass || (noDefault ? undefined : settings.defaultIngressClass)
  const ingress: V1Ingress = {
    apiVersion: "networking.k8s.io/v1",
    kind: K8SResourceType.Ingress,
    metadata: {
      name: planData.workloadName,
      annotations: Object.assign(
        getExternalDNSAnnotations(appAccess, settings, "ingress"), defaultAnnotations, appAccess.advancedFeatures?.ingressAnnotations) as KVString,
      labels: Object.assign({ workload: planData.workloadName }, defaultLabels, appAccess.advancedFeatures?.ingressLabels || {}) as KVString
    },
    spec: {
      ingressClassName,
      tls: [{
        hosts,
        secretName: appAccess.cert || settings.defaultTlsCert as string
      }],
      rules: hosts.map(host => {
        return {
          host,
          http: {
            paths: (appAccess.paths || ['/']).map(p => {
              if (typeof p === "string") {
                return {
                  path: p,
                  pathType: defaultPathType,
                  backend: {
                    service: defaultBackend
                  }
                } as V1HTTPIngressPath
              } else {
                return {
                  path: p.path,
                  pathType: p.pathType || defaultPathType,
                  backend: {
                    service: p.backend || defaultBackend
                  }
                } as V1HTTPIngressPath
              }
            })
          }
        }
      })
    }
  }
  return ingress
}